<template>
  <div>
    <app-component-empty-state v-if="loading == false && desserts.length == 0"
      :title="'Ops! Não existem canais cadastrados'"
      :text="'Clique em “Novo Canal” para começar a cadastrar canais no sistema.'">
    </app-component-empty-state>
    <v-card v-else>
        <v-col md="5" class="mb-4">
          <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar Canais"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
        <v-data-table
          :loading="loading" loading-text="Carregando..."
          :headers="headers"
          :items="desserts"
          :search="search"
        >
          <template v-slot:item.is_authorized="{ item }">
            <span v-if="item.is_authorized">Autorizado</span>
            <span v-else class="blue--text text--darken-3 pointer" @click="authChannel(item.id_youtube_channel)">Aguardando</span>
          </template>
          <template v-slot:item.created_on_youtube_at="{ item }">
              <span>{{moment(String(item.created_on_youtube_at)).format('DD/MM/YYYY')}}</span>
          </template>
          <template v-slot:item.price="{ item }">
              <span>{{formatterMoney.format(item.price)}}</span>
          </template>
          <template v-slot:item.bought_at="{ item }">
              <span>{{moment(String(item.bought_at)).format('DD/MM/YYYY')}}</span>
          </template>
          <template v-slot:item.assets_groups="{ item }">
            <span v-if="item.assets_groups.length > 0"> Sim </span>
            <span v-else> Não </span>
          </template>
          <template v-slot:item.channel_group="{ item }">
            <v-icon :color="item.channel_group" size="16">
              mdi-checkbox-blank-circle
            </v-icon>
          </template>
          <template v-slot:item.actions="{ item }">
            <app-channels-edit :channel="item" v-on:notification="notification = $event" @getData="getChannels"></app-channels-edit>
          </template>
        </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
import ChannelsEdit from './ChannelsEdit.vue'
import EmptyState from '../components/EmptyState.vue'

export default {
    components: {
      'app-channels-edit': ChannelsEdit,
      'app-component-empty-state': EmptyState
    },
    props: {
      loadData: {
        type: Boolean,
        required: true,
        default: null
      }
    },
    watch: {
      loadData: function () {
        this.getChannels();
        this.$emit('loadFalse')
      },
      notification: function() {
        this.$emit('notification', this.notification);
      }
    },
    created() {
      this.getChannels();
    },
    data: () => ({
        moment: moment,
        search: '',
        loading: true,
        formatterMoney: new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}),
        headers: [
          { text: 'Nome', align: 'start', sortable: true, value: 'name' },
          { text: 'ID YT', align: 'start', sortable: true, value: 'channel_id_youtube' },
          { text: 'Status', align: 'start', sortable: true, value: 'is_authorized' },
          { text: 'Data Aquisição', value: 'bought_at', sortable: false },
          { text: 'Data Criação', value: 'created_on_youtube_at', sortable: false },
          { text: 'Valor Compra', value: 'price', sortable: false },
          { text: 'Categoria', value: 'channel_group', align: 'center', sortable: false },
          { text: 'Possui Grupo de Assets', value: 'assets_groups', sortable: false, align: 'center' },
          { text: 'Ações', align: 'center', value: 'actions', sortable: false, filterable: false },
        ],
        desserts: [],
        notification: {
          active: false,
          description: '',
          type: '',
          closeText: ''
        }
    }),
    methods: {
      getChannels() {
        this.$http.get( '/channel' )
        .then( ( res ) => {
          this.desserts = res.data;
        } ).catch( () => {
          this.notification = {
            active: true,
            description: 'Houve um erro na solicitação.',
            type: 'error',
            closeText: 'Fechar'
          },
          this.$emit( 'notification', this.notification );
        } ).finally( () => {
          this.loading = false;
        } );
      },
      authChannel(channel) {
         this.$http.post( '/youtube-auth', {
          id_youtube_channel: channel,
        })
        .then( (res) => {
          window.open(res.data.url, "authwindow", "height=580,width=620")
        })
      }
    }
}
</script>

<style scoped>
  .d-content {
    display: contents !important;
  }
  .table-min-height {
    min-height: 60vh;
  }
</style>